module.exports = __webpack_public_path__ + "media/images/lb/539-37fa3f2ebbdcb39939ed0db9f13a4e1e.svg";